export enum PromptType {
  First = 'first',
  Second = 'second',
  AreYouSure = 'areYouSure',
  Feedback = 'feedback',
  Unpause = 'unpause',
  Pause = 'pause',
}
